import { Typography } from "@commonlibs";
import useTranslate from "ui/locale/hooks/useTranslate";

export default function DailySchedule() {
    const translate = useTranslate();
    return <Typography variant="body3Regular">{translate("dailyScheduleExplanation")}</Typography>;
}
